<div class="loader" [ngClass]="(httpStatus.requestInFlight$|async)? 'active': ''">
  <mat-progress-bar class="fixed-top" *ngIf="(httpStatus.requestInFlight$|async)" mode="indeterminate" color="primary">
  </mat-progress-bar>
</div>

<router-outlet></router-outlet>

<!-- <button class="support-btn" mat-fab color="primary" (click)="openBottomSheet()" matTooltip="Need help?"
  #tooltip="matTooltip" matTooltipPosition="above" matTooltipClass="sbm-tooltip">
  <mat-icon class="support-icon">contact_support</mat-icon>
</button> -->
